import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useState } from 'react';
import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import styled from 'styled-components';
import CoreSeatsExplainerModal from 'ui-addon-upgrades/_core/common/components/seatsModals/CoreSeatsExplainerModal';
import UILink from 'UIComponents/link/UILink';
import { useAppSelector } from '../../../reducers';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { calculatedPriceSelector } from '../../../selectors/PricingSelectors';
import { coreSeatSkuForProductLevelSelector, includedCoreSeatsQuantityForProductVersionSelector, includedCoreSeatsQuantityForSuiteProductLevelSelector } from '../../../selectors/ProductsSelectors';
const DescriptionContainer = styled.div.withConfig({
  displayName: "CoreSeatsDescription__DescriptionContainer",
  componentId: "fraa5l-0"
})(["line-height:2;font-size:12px;margin:0 auto;margin-top:8px;"]);

const CoreSeatsDescription = ({
  productLevel,
  skuId,
  trackingSource,
  isSuite = false
}) => {
  const currencyCode = useAppSelector(activeCurrencySelector);
  const [coreSeatsExplainerVisible, setCoreSeatsExplainerVisible] = useState(false);
  const includedSeats = useAppSelector(state => {
    return isSuite ? includedCoreSeatsQuantityForSuiteProductLevelSelector(state, {
      suiteProductLevel: productLevel
    }) : includedCoreSeatsQuantityForProductVersionSelector(state, {
      productVersionSkuId: skuId
    });
  });
  const coreSeatProPrice = useAppSelector(state => {
    const {
      skuId: coreSeatSkuId
    } = coreSeatSkuForProductLevelSelector(state, {
      productLevel: PROFESSIONAL
    });
    return calculatedPriceSelector(state, {
      productConfigurations: [createProductConfig({
        skuId: coreSeatSkuId
      })]
    });
  });

  const handleLinkClick = () => {
    setCoreSeatsExplainerVisible(true);
    getUsageTracker().track('clickToViewModal', {
      name: 'core-seats-explainer-modal',
      location: trackingSource
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [coreSeatsExplainerVisible && /*#__PURE__*/_jsx(CoreSeatsExplainerModal, {
      handleModalClose: () => setCoreSeatsExplainerVisible(false),
      currencyCode: currencyCode,
      coreSeatProPrice: coreSeatProPrice.monthly.calculatedPrice
    }), /*#__PURE__*/_jsx(DescriptionContainer, {
      className: "flex-column align-start",
      children: /*#__PURE__*/_jsx("span", {
        style: {
          fontWeight: 600,
          fontSize: '14px'
        },
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `interstitial.coreSeats.title.${productLevel}_jsx`,
          options: {
            count: includedSeats
          },
          elements: {
            Link: ({
              children
            }) => /*#__PURE__*/_jsx(UILink, {
              onClick: handleLinkClick,
              children: children
            })
          }
        })
      })
    })]
  });
};

export default CoreSeatsDescription;